(() => {
    function initPairWith(root) {
      if (!root || root.dataset.pairWithInitialized === 'true') return;
      root.dataset.pairWithInitialized = 'true';
  
      const productCards = Array.from(root.querySelectorAll('.pair-with__item'));
      const listEl = root.querySelector('.pair-with__list');
      const modal = root.querySelector('[data-pair-with-modal]');
      const prevArrow = root.querySelector('[data-pair-with-prev]');
      const nextArrow = root.querySelector('[data-pair-with-next]');
      const modalProductTitle = root.querySelector('[data-modal-product-title]');
      const errorEl = root.querySelector('[data-pair-with-error]');
      const confirmBtn = root.querySelector('[data-confirm-pair-with]');
      const closeModalBtn = root.querySelector('[data-close-pair-with-modal]');
      let selectedVariantId = null;

      function lockBodyScroll() {
        document.documentElement.style.overflow = 'hidden';
      }

      function unlockBodyScroll() {
        document.documentElement.style.overflow = '';
      }

      const pairWithCount = Number(listEl?.dataset.pairWithCount || 0);
      const shouldUseSlider = pairWithCount > 2;
      const nav = root.querySelector('.pair-with__nav');

      // ─── Index-based native scroll ────────────────────────────────────────
      let currentIndex = 0;

      function getSlidesVisible() {
        if (window.innerWidth >= 550) return 3;
        if (window.innerWidth >= 380) return 2;
        return 1;
      }

      // ─── Responsive nav visibility ────────────────────────────────────────
      function updateNavVisibility() {
        if (!nav) return;
        nav.hidden = pairWithCount <= getSlidesVisible();
      }
  
      function scrollToIndex(index) {
        if (!listEl || !productCards.length) return;
        const maxIndex = Math.max(0, productCards.length - getSlidesVisible());
        currentIndex = Math.max(0, Math.min(index, maxIndex));
  
        const cardWidth = productCards[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(listEl).columnGap) || 16;
        listEl.scrollTo({ left: currentIndex * (cardWidth + gap), behavior: 'smooth' });
      }
  
      // ─── Slick slider ─────────────────────────────────────────────────────
      function enableNativeScrollFallback() {
        if (!listEl) return;
        listEl.classList.add('pair-with__list--scroll-fallback');
      }
  
      function initSlickSlider(attempt = 0) {
        if (!shouldUseSlider || !listEl) return;
  
        if (window.jQuery && typeof window.jQuery.fn.slick === 'function') {
          if (!window.jQuery(listEl).hasClass('slick-initialized')) {
            listEl.classList.remove('pair-with__list--scroll-fallback');
            window.jQuery(listEl).slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              arrows: false,
              adaptiveHeight: false,
              responsive: [
                { breakpoint: 550, settings: { slidesToShow: 2 } },
                { breakpoint: 380, settings: { slidesToShow: 1 } }
              ]
            });
          }
          return;
        }
  
        if (attempt < 20) {
          window.setTimeout(() => initSlickSlider(attempt + 1), 200);
        } else {
          enableNativeScrollFallback();
        }
      }
  
      if (shouldUseSlider) {
        enableNativeScrollFallback();
        initSlickSlider();
        window.addEventListener('load', () => initSlickSlider(), { once: true });
      }

      updateNavVisibility();
      window.addEventListener('resize', updateNavVisibility);

      // ─── Arrow navigation ─────────────────────────────────────────────────
      if (prevArrow) {
        prevArrow.addEventListener('click', () => {
          if (window.jQuery && listEl && window.jQuery(listEl).hasClass('slick-initialized')) {
            window.jQuery(listEl).slick('slickPrev');
          } else {
            scrollToIndex(currentIndex - 1);
          }
        });
      }
  
      if (nextArrow) {
        nextArrow.addEventListener('click', () => {
          if (window.jQuery && listEl && window.jQuery(listEl).hasClass('slick-initialized')) {
            window.jQuery(listEl).slick('slickNext');
          } else {
            scrollToIndex(currentIndex + 1);
          }
        });
      }
  
      // ─── Cart ─────────────────────────────────────────────────────────────
      async function refreshCartUi() {
        if (window.eventBus) {
          window.eventBus.emit('render:cart:drawer');
          window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
        } else {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          const drawer = document.querySelector('.js-cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
          }
        }
      }
  
      async function addVariantToCart(variantId, triggerButton) {
        if (!variantId) return;
  
        if (triggerButton) {
          triggerButton.disabled = true;
          triggerButton.classList.add('is-loading');
          triggerButton.setAttribute('aria-busy', 'true');
        }
  
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
  
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
  
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data?.description || data?.message || 'Unable to add this item.');
          }
  
          if (modal && typeof modal.close === 'function' && modal.open) {
            modal.close();
          }

          try {
            const cartRes = await fetch('/cart.js');
            const cartData = await cartRes.json();
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
              window.wetheme.updateCartCount(cartData);
            }
          } catch (_e) {}

          await refreshCartUi();
        } catch (error) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = error.message || 'Unable to add this item.';
          }
        } finally {
          if (triggerButton) {
            triggerButton.disabled = false;
            triggerButton.classList.remove('is-loading');
            triggerButton.removeAttribute('aria-busy');
          }
        }
      }
  
      // ─── Variant modal ────────────────────────────────────────────────────
      function openVariantModal(productData) {
        if (!modal) return;

        let variantPillsContainer = root.querySelector('[data-pair-with-variant-pills]');
        if (!variantPillsContainer) {
          const modalContent = modal.querySelector('.pair-with__modal-content');
          if (!modalContent) return;

          // Hide old select + its label if present (legacy liquid)
          const oldSelect = modalContent.querySelector('[data-pair-with-variant-select]');
          if (oldSelect) {
            oldSelect.style.display = 'none';
            const oldLabel = modalContent.querySelector('.pair-with__modal-label');
            if (oldLabel) oldLabel.style.display = 'none';
          }

          variantPillsContainer = document.createElement('div');
          variantPillsContainer.className = 'pair-with__variant-pills';
          variantPillsContainer.setAttribute('data-pair-with-variant-pills', '');
          const errEl = modalContent.querySelector('[data-pair-with-error]');
          errEl
            ? modalContent.insertBefore(variantPillsContainer, errEl)
            : modalContent.appendChild(variantPillsContainer);
        }

        const availableVariants = (productData.variants || []).filter((v) => v.available);
        variantPillsContainer.innerHTML = '';
        selectedVariantId = null;

        availableVariants.forEach((variant, index) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pair-with__variant-pill';
          btn.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
          btn.textContent = variant.title;

          btn.addEventListener('click', () => {
            variantPillsContainer.querySelectorAll('.pair-with__variant-pill').forEach((p) => {
              p.setAttribute('aria-pressed', 'false');
            });
            btn.setAttribute('aria-pressed', 'true');
            selectedVariantId = variant.id;
          });

          variantPillsContainer.appendChild(btn);
          if (index === 0) selectedVariantId = variant.id;
        });

        if (modalProductTitle) {
          modalProductTitle.textContent = productData.title || '';
        }
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        if (typeof modal.showModal === 'function') {
          lockBodyScroll();
          modal.showModal();
        } else {
          lockBodyScroll();
          modal.setAttribute('open', '');
        }
      }

      if (confirmBtn) {
        confirmBtn.addEventListener('click', () => addVariantToCart(selectedVariantId, confirmBtn));
      }

      function closeModal() {
        if (!modal?.open) return;
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
          unlockBodyScroll();
        }
      }

      if (closeModalBtn) {
        closeModalBtn.addEventListener('click', closeModal);
      }

      if (modal) {
        modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
        modal.addEventListener('close', () => { unlockBodyScroll(); });
      }
  
      productCards.forEach((card) => {
        const addBtn = card.querySelector('[data-add-pair-with]');
        const productJsonEl = card.querySelector('[data-product-json]');
        if (!addBtn || !productJsonEl) return;
  
        let productData = null;
        try {
          productData = JSON.parse(productJsonEl.textContent);
        } catch (_e) {
          productData = null;
        }
        if (!productData) return;
  
        addBtn.addEventListener('click', () => {
          const available = (productData.variants || []).filter((v) => v.available);
          if (available.length === 0) return;
          if (available.length === 1) {
            addVariantToCart(available[0].id, addBtn);
            return;
          }
          openVariantModal(productData);
        });
      });
    }
  
    function initAllPairWith() {
      document.querySelectorAll('.pair-with').forEach((s) => initPairWith(s));
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPairWith);
    } else {
      initAllPairWith();
    }
  
    document.addEventListener('shopify:section:load', initAllPairWith);
  })();
  